export function fromValues (data, labelKey, valueKey) {
  return data.map((value, index) => {
    return {
      id: index,
      label: value[labelKey],
      value: value[valueKey]
    }
  })
}

export function fromKeys (data, firstObj = {}) {
  data = {
    ...firstObj,
    ...data
  }
  return Object.keys(data).map((key, index) => {
    return {
      id: index,
      label: key,
      value: data[key]
    }
  })
}

export function mapListFilter ({ obj, id, label, value }) {
  return obj.map(el => {
    return {
      id: el[id],
      label: el[label],
      value: el[value]
    }
  })
}

export function fromArrayKeys(data, firstObj = {}) {
  data = {
    ...firstObj,
    ...data
  }
  
  const results = Object.keys(data).map(x => {
    return { 
      [x]: data[x].map((y) => {
        return {
          id: y.id,
          title: y.title,
          label: y.title,
          value: y.id,
        }
      })
    }
  })
  
  const object = results.reduce((obj, item) => Object.assign(obj, item), {});

  return object
}

export function fromArrayKeysName(data, firstObj = {}) {
  data = {
    ...firstObj,
    ...data
  }
  
  const results = Object.keys(data).map(x => {
    return { 
      [x]: data[x].map((y) => {
        return {
          id: y.id,
          title: y.name,
          label: y.name,
          value: y.id,
        }
      })
    }
  })
  
  const object = results.reduce((obj, item) => Object.assign(obj, item), {});

  return object
}
